import type { Id, TableNames } from '@convex/_generated/dataModel'
import type { SystemTableNames } from 'convex/server'
import { notFound } from 'next/navigation'
import { readUnknownProperty } from '@shared/validation/narrow'

const CONVEX_ID_PATTERN = /^[a-z0-9]{32}$/

export function isValidConvexId(id: string): boolean {
 return CONVEX_ID_PATTERN.test(id)
}

export function isConvexId<T extends TableNames | SystemTableNames>(
  id: unknown,
): id is Id<T> {
  return typeof id === 'string' && CONVEX_ID_PATTERN.test(id)
}

export function parseConvexId<T extends TableNames>(id: string | null): Id<T> | null {
 return isConvexId<T>(id) ? id : null
}

export function validateIdOrNotFound<T extends TableNames>(
  id: string,
  table: T,
): Id<T> {
  void table
  if (!isConvexId<T>(id)) {
    notFound()
  }
  return id
}

export function readUploadedStorageId(body: unknown): Id<'_storage'> | undefined {
  const storageId = readUnknownProperty(body, 'storageId')
  return typeof storageId === 'string' && isConvexId<'_storage'>(storageId)
    ? storageId
    : undefined
}

export function requireUploadedStorageId(body: unknown): Id<'_storage'> {
  const storageId = readUploadedStorageId(body)
  if (!storageId) throw new Error('Upload response did not include a storage id')
  return storageId
}
